console.log('🏠 Vite ⚡️ Rails 💪 Humaniz 🧑‍💻');
import '../assets/tailwind.css'; // Import CSS directly here
import { createApp } from 'vue';
import * as Vue from 'vue';
import App from '../App.vue';
import router from '../router/index.js';
import store from '../stores/index.js';
import { plugin, defaultConfig } from '@formkit/vue';
import VueFeather from 'vue-feather';
import ActionCableVue from 'actioncable-vue';
import config from '../../../formkit.config.js';
import { setupGlobalHMR } from '../hmr.js';

import TButton from '../components/shared/TButton.vue';
import TButtonSvg from '../components/shared/TButtonSvg.vue';
import TextInput from '../components/shared/TextInput.vue';
import TextAreaInput from '../components/shared/TextAreaInput.vue';
import NumberInput from '../components/shared/NumberInput.vue';
import CurrencyInput from '../components/shared/CurrencyInput.vue';
import DateInput from '../components/shared/DateInput.vue';
import DateTimeInput from '../components/shared/DateTimeInput.vue';
import TimeInput from '../components/shared/TimeInput.vue';
import FileInput from '../components/shared/FileInput.vue';
import PasswordInput from '../components/shared/PasswordInput.vue';
import ToggleInput from '../components/shared/ToggleInput.vue';
import CheckboxInput from '../components/shared/CheckboxInput.vue';
import PhoneInput from '../components/shared/PhoneInput.vue';
import SelectMenu from '../components/shared/SelectMenu.vue';
import LocalLoadingSpinner from '../components/shared/LocalLoadingSpinner.vue';

import { ApiPlugin } from '../api/index.ts';

// Create and configure the Vue application
const app = createApp(App);
setupGlobalHMR(app);

// Use plugins
app.use(store);
app.use(router);
app.use(plugin, defaultConfig(config));
app.use(ApiPlugin);
app.use(ActionCableVue, {
  debug: process.env.NODE_ENV !== 'production',
  debugLevel: 'error',
  connectionUrl: process.env.NODE_ENV === 'production' ? 'wss://app.humaniz.io/cable' : 'ws://localhost:3000/cable',
  connectImmediately: true,
  unsubscribeOnUnmount: true,
});

// Register global components
app.component('TButton', TButton);
app.component('TButtonSvg', TButtonSvg);
app.component('TextInput', TextInput);
app.component('TextAreaInput', TextAreaInput);
app.component('NumberInput', NumberInput);
app.component('CurrencyInput', CurrencyInput);
app.component('DateInput', DateInput);
app.component('DateTimeInput', DateTimeInput);
app.component('TimeInput', TimeInput);
app.component('FileInput', FileInput);
app.component('PasswordInput', PasswordInput);
app.component('ToggleInput', ToggleInput);
app.component('CheckboxInput', CheckboxInput);
app.component('PhoneInput', PhoneInput);
app.component('SelectMenu', SelectMenu);
app.component('LocalLoadingSpinner', LocalLoadingSpinner);
app.component(VueFeather.name ?? '', VueFeather);

// Mount the app when the DOM is ready
if (document.readyState !== 'loading') {
  mountApp();
} else {
  document.addEventListener('DOMContentLoaded', mountApp);
}

function mountApp() {
  const root = app.mount('#app');
  window.vueApp = root;
}

// Enable HMR for development
if (import.meta.hot) {
  import.meta.hot.accept();
}
